// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__3dYp8","decoration":"footer_decoration__1AW9I"};